import { Component, Inject, OnInit } from '@angular/core';
import { MyStripeService } from '../../../services/apiclient/myStripe/my-stripe.service';
//////////////////////////////////////////////////
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ResponseService } from 'src/app/services/manage/response/response.service';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { Observable, fromEvent } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';

declare var Stripe: any;

@Component({
  selector: 'app-stripe-card-sca',
  templateUrl: './stripe-card-sca.component.html',
  styleUrls: ['./stripe-card-sca.component.css']
})

export class StripeCardScaComponent implements OnInit {

  eventHeight: Observable<any> = fromEvent(window, "resize");
  innerHeight: number = window.innerHeight;

  stripe: any;

  elements: any;

  cardNumber: any;
  cardExpiry: any;
  cardCvc: any;

  card: any;

  elementStyles: any = {
    base: {
      iconColor: '#666EE8',
      color: '#31325F',
      lineHeight: '40px',
      fontWeight: 'bold',
      fontFamily: 'sans-serif',
      fontSize: '18px',
      textAlign: 'center',

      '::placeholder': {
        color: '#CFD7E0',
      }
    }
  };

  lang: any = this.tools.getStor("lang") ? this.tools.getStor("lang") : "fr";

  errorMessage: string | any;

  rememberCard: boolean = true;

  loader: boolean = false;
  user$: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    // private myStripeApi: MyStripeService,
    private myStripeApi: MyStripeService,
    public dialogRef: MatDialogRef<StripeCardScaComponent>,
    private responseServ: ResponseService,
    private tools: ToolsService,
    private auth: AuthService,
    public translate: TranslateService
  ) {
    /**
      * @description  get User 
      */
    this.auth.getUser.subscribe(user => {
      this.user$ = user;
      if (!user) {
        this.rememberCard = false;
      }
    });
  }

  ngOnInit() {
    this.onWindowResize();
    this.handleStripe();
  }

  /**
   * @description Initialise stripe et le formulaire de nouvelle carte
   */
  handleStripe(): void {



    if (this.cardNumber) {
      this.cardNumber.unmount();
      this.cardExpiry.unmount();
      this.cardCvc.unmount();
      this.cardNumber = null;
      this.cardExpiry = null;
      this.cardCvc = null;
    }


    // Init stripe key
    // this.myStripeApi.getStripeKey().subscribe(key => {
    this.myStripeApi.getStripeKey().subscribe(key => {



      if (key) {
        this.stripe = Stripe(key);

        this.elements = this.stripe.elements({
          locale: this.lang
        });

        this.cardNumber = this.elements.create('cardNumber', {
          style: this.elementStyles,
        });

        this.cardExpiry = this.elements.create('cardExpiry', {
          style: this.elementStyles,
        });

        this.cardCvc = this.elements.create('cardCvc', {
          style: this.elementStyles,
        });

        this.cardNumber.mount('#cardNumber');
        this.cardExpiry.mount('#cardExpiry');
        this.cardCvc.mount('#cardCvc');

      }
    });
  }

  /**
   * @description Crée une carte
   */
  submitForm() {

    const that = this;
    that.loader = true;
    that.errorMessage = null;
    that.dialogRef.disableClose = true;

    that.stripe.createPaymentMethod(
      'card',
      that.cardNumber
    ).then(function (result: any) {


      if (result.error) {

        that.errorMessage = result.error.message //that.responseServ.getErrorMessage(500);
        that.loader = false;
        that.dialogRef.disableClose = false;
        setTimeout(() => {
          that.errorMessage = null
        }, 4000);

      } else {

        if (that.rememberCard) {

          // that.myStripeApi.createPaymentMethod(result.paymentMethod.id).subscribe(data => {
          that.myStripeApi.createPaymentMethod(result.paymentMethod.id).subscribe(data => {

            if (data.code < 0) {

              //traduction erreur
              if (data.err && data.err.code) {
                that.translate.get('stripeErrors').subscribe((trad: any) => {
                  let code = trad[data.err.code] ? trad[data.err.code]() : null;
                  data.err.code = code ? code : trad['error']() + "(" + data.err.code + ")";
                });
              }

              that.errorMessage = data.err && data.err.code ? data.err.code : data.message;


              that.loader = false;
              that.dialogRef.disableClose = false;

            } else {

              that.dialogRef.close({ from: "saved", cards: data.paymentMethods });


              that.tools.openSnackBar(that.translate.instant("stripeCustomer.CardCreated"), "great");

            }

          })

        } else {
          // const momentaryCard = that.myStripeApi.createMomentaryCard(result.paymentMethod);
          const momentaryCard = that.myStripeApi.createMomentaryCard(result.paymentMethod);
          that.dialogRef.close({ from: "momentary", card: momentaryCard });


        }

      }

    });

  }

  onWindowResize() {
    this.eventHeight.subscribe(event => {
      this.innerHeight = event.target.innerHeight;
    });
  }
  closeDial() {
    this.dialogRef.close();
  }
}
